/*
  Nhãn dán trên nút chọn size ("Best gift size"…).

  VÌ SAO PHẢI CÓ JS

  Nút size có `overflow: clip` để giấu `.variant-option__button-label__pill` —
  khối nền trượt khi chọn, vốn nằm tròi ra ngoài khung nút. Hệ quả: mọi thứ vẽ
  trong nút mà vượt mép đều bị cắt. Ba cách thuần CSS đã thử và đều hỏng
  (24/08/2026):

    · mở `overflow` cho nhãn thò ra → lòi luôn khối nền, thành một nút nâu rỗng;
    · nhãn nằm gọn trong góc        → che mất chữ size;
    · nhãn nằm inline cạnh chữ      → nút phình ngang, hàng nút vỡ xuống hai dòng.

  Nên nhãn được bê RA NGOÀI nút, thành con của `fieldset` (thẻ này không cắt),
  rồi đặt toạ độ theo đúng nút của nó. Nút giữ nguyên kích thước, hàng vẫn thẳng.

  ĐO TOẠ ĐỘ BẰNG ResizeObserver, KHÔNG ĐO TRONG VÒNG LẶP (22/09/2026).

  Bản cũ cứ 400ms lại bật/tắt `visibility` của nhãn, ghi `inset` rồi đọc
  `offsetWidth` — mỗi nhịp ép trình duyệt tính lại style CẢ TRANG ngay lập tức.
  Đo trang sản phẩm mobile Slow 4G + CPU x4: 40 nhịp × ~56ms = 2,25s luồng chính,
  2,1s trong đó là UpdateLayoutTree — nhiều hơn cả customily.js, và rơi đúng
  lúc Customily đang cần CPU để dựng ô nhập tên.

  Giờ tách hai việc:
    · vòng lặp 400ms chỉ còn DÒ DOM (querySelector, không đụng style) để bắt
      lúc Horizon dựng lại section khi đổi size — nhãn mới lại nằm trong nút;
    · toạ độ đặt trong callback ResizeObserver: chạy sau layout của khung hình
      nên đọc rect không ép gì thêm. Nút co giãn, font tải xong, cửa sổ đổi cỡ
      đều làm host/nút/nhãn đổi kích thước nên đều bắn callback.
  Trong callback: ĐỌC hết rồi mới GHI, và chỉ ghi khi giá trị khác.

  Thêm MutationObserver trên khối variant-picker: đổi size là Horizon morph lại
  và chèn nhãn mới vào nút — bắt ngay lúc đó thì nhãn không biến mất 0–400ms chờ
  nhịp poll. Poll vẫn giữ làm lưới an toàn.

  Gắn `data-has-flag` lên fieldset: CSS chừa 0.5rem phía trên cho nhãn nhô lên,
  mà luật `:has(.variant-option__flag)` hết khớp khi nhãn đã bê ra ngoài → cả
  khối nhảy 8px lúc tải và mỗi lần đổi size (đo 22/09/2026: form 146 → 138px).
*/
(function () {
  const POLL_MS = 400;
  let observer = null;
  let mutations = null;

  /*
    Bê nhãn ra khỏi nút và gắn vào FORM, KHÔNG gắn vào <fieldset>.

    <fieldset> là thẻ đặc biệt: con định vị tuyệt đối bên trong nó lấy mốc từ
    hộp NỘI DUNG — tức là sau <legend>. Đo 24/08/2026: đặt top = 32.6px mà nhãn
    rơi xuống 66px, lệch đúng chiều cao chữ "Size". Gắn vào form (thẻ thường)
    thì mốc đúng như mong đợi.
  */
  function hostOf(fieldset) {
    return fieldset.closest('.variant-picker__form') || fieldset.parentElement;
  }

  function fieldsets() {
    return document.querySelectorAll('.variant-option--buttons');
  }

  /* Trả về true nếu có nhãn mới vừa được bê ra (section vừa dựng lại). */
  function adopt(fieldset) {
    const host = hostOf(fieldset);
    if (!host) return false;

    const fresh = fieldset.querySelectorAll('label [data-variant-flag]');
    if (!fresh.length) return false;

    /* Gán chỉ số nút cho từng nhãn TRƯỚC khi bê ra, lúc nhãn còn nằm trong label. */
    fieldset.querySelectorAll('.variant-option__button-label').forEach((label, i) => {
      const flag = label.querySelector('[data-variant-flag]');
      if (flag) {
        flag.dataset.labelIndex = String(i);
        /* 21/10/2026: nhiều nhóm nút (Size + Style) dùng chung host → nhớ nhãn thuộc nhóm nào,
           không thì nhãn của Size bị đặt theo nút cùng số thứ tự của nhóm cuối (Style). */
        flag.__pfFieldset = fieldset;
      }
    });

    /* Phải bỏ `hidden` TRƯỚC khi đo: thẻ đang display:none thì offsetHeight = 0,
       nhãn sẽ dán lệch xuống đúng nửa chiều cao của chính nó. Giấu bằng
       visibility tới khi có toạ độ. */
    fieldset.setAttribute('data-has-flag', '');
    fresh.forEach((flag) => {
      flag.style.visibility = 'hidden';
      flag.hidden = false;
      host.appendChild(flag);
    });
    return true;
  }

  function placeAll() {
    /*
      Đo bằng getBoundingClientRect chứ KHÔNG dùng offsetTop/offsetLeft.

      `offsetTop` tính theo offsetParent — mà offsetParent có thể không phải cái
      fieldset mình đang định vị vào (legend, khung ngoài, hay bất cứ thẻ nào
      được đặt position ở giữa đều chen vào). Đo 24/08/2026: nhãn rơi xuống giữa
      nút, đè lên chữ size. Lấy hiệu hai rect thì luôn đúng, bất kể cây DOM.
    */
    const moves = [];
    const widen = [];
    fieldsets().forEach((fieldset) => {
      const host = hostOf(fieldset);
      if (!host) return;
      const flags = host.querySelectorAll(':scope > [data-variant-flag]');
      if (!flags.length) return;

      const labels = fieldset.querySelectorAll('.variant-option__button-label');
      const box = host.getBoundingClientRect();

      flags.forEach((flag) => {
        if (flag.__pfFieldset && flag.__pfFieldset !== fieldset) return;
        const label = labels[flag.dataset.labelIndex];
        if (!label) return;
        const rect = label.getBoundingClientRect();
        const fw = flag.offsetWidth;
        /* 24/10/2026: nút size đã thu gọn theo chữ (23/10) nên hẹp hơn nhãn → nhãn canh
           phải tràn sang nút bên trái, khách không biết nhãn của nút nào. Giờ: nút có nhãn
           được nới tối thiểu = nhãn + 16px, và nhãn đặt CHÍNH GIỮA nút. */
        const need = Math.ceil(fw + 16);
        if (fw && rect.width < need && label.style.minWidth !== need + 'px') widen.push([label, need + 'px']);
        moves.push([
          flag,
          rect.left - box.left + (rect.width - fw) / 2 + 'px',
          /* Nhô lên khỏi mép nút đúng nửa chiều cao nhãn: nhìn ra là dán lên viền,
             không phải nằm trong nút cũng không phải trôi hẳn ra ngoài. */
          rect.top - box.top - flag.offsetHeight / 2 + 'px',
        ]);
      });
    });

    /* Nới nút trước; ResizeObserver bắt nút đổi cỡ và gọi lại để đặt nhãn đúng giữa. */
    widen.forEach(([label, w]) => { label.style.minWidth = w; });

    moves.forEach(([flag, x, y]) => {
      if (flag.style.insetInlineStart !== x) flag.style.insetInlineStart = x;
      if (flag.style.insetBlockStart !== y) flag.style.insetBlockStart = y;
      if (flag.style.visibility) flag.style.visibility = '';
    });
  }

  /* Theo dõi lại từ đầu mỗi lần section dựng lại: phần tử cũ đã bị gỡ khỏi trang. */
  function watch() {
    if (observer) observer.disconnect();
    if (mutations) mutations.disconnect();
    observer = new ResizeObserver(placeAll);
    mutations = new MutationObserver(tick);
    fieldsets().forEach((fieldset) => {
      const host = hostOf(fieldset);
      if (!host) return;
      observer.observe(host);
      fieldset.querySelectorAll('.variant-option__button-label').forEach((label) => observer.observe(label));
      host.querySelectorAll(':scope > [data-variant-flag]').forEach((flag) => observer.observe(flag));
      mutations.observe(host.closest('variant-picker') || host, { childList: true, subtree: true });
    });
  }

  function tick() {
    if (document.hidden) return;
    let fresh = false;
    fieldsets().forEach((fieldset) => {
      if (adopt(fieldset)) fresh = true;
    });
    /* observe() luôn bắn callback lần đầu, nên nhãn mới được đặt ngay khung hình sau. */
    if (fresh) watch();
  }

  tick();
  setInterval(tick, POLL_MS);
  document.addEventListener('shopify:section:load', tick);
})();
